/**
 * rondo-web-forms
 *
 * Rondo Web Forms
 *
 * @author Jiri Hybek <jiri@hybek.cz>
 * @license See LICENSE file distributed with this source code.
 */

import React from "react"

import { Form } from "../shared/FormModel/FormModel";
import { SectionGroup } from "../shared/FormModel/elements/FormSectionGroup";
import { Section } from "../shared/FormModel/elements/FormSection";
import { Row } from "../shared/FormModel/elements/FormRow";
import { FieldText } from "../shared/FormModel/elements/FormFieldText";
import { FieldSelect } from "../shared/FormModel/elements/FormFieldSelect";
import { FieldLabel } from "../shared/FormModel/elements/FormFieldLabel";
import { HTMLContent } from "../shared/FormModel/elements/FormHTMLContent";

export const form_zadavaciProtokol = Form({
	id: "zadavaci-protokol",
	version: "2020-06-r1",
	title: "Zadávací protokol - online + tisk",
	icon: "clipboard-text",
	showInMenu: true
}, [
	SectionGroup({}, [
		Section({
			id: "zakazka",
			title: "Zakázka"
		}, [
			Row({}, [
				FieldText({
					width: "1/4",
					id: "datum",
					label: "Datum",
					placeholder: "d.m.R",
					required: true
				}),
				FieldText({
					width: "3/4",
					id: "zakaznik",
					label: "Zákazník",
					placeholder: "Jan Novák",
					required: true
				})
			]),
			Row({}, [
				FieldText({
					id: "adresa_ulice",
					label: "Ulice a č.p.",
					placeholder: "Ulice 123",
					required: true
				}),
				FieldText({
					width: "2/6",
					id: "adresa_mesto",
					label: "Město",
					placeholder: "Město",
					required: true
				}),
				FieldText({
					width: "1/6",
					id: "adresa_psc",
					label: "PSČ",
					placeholder: "123 45",
					required: true
				}),
			]),
			Row({}, [
				FieldText({
					id: "kontakt_email",
					label: "E-mail",
					placeholder: "jan@novak.tld"
				}),
				FieldText({
					width: "1/3",
					id: "kontakt_telefon",
					label: "Telefon",
					placeholder: "+420 123 456 789"
				})
			]),
			Row({}, [
				FieldText({
					id: "realizace_misto",
					label: "Místo realizace",
					placeholder: "Adresa, město, PSČ"
				}),
				FieldText({
					width: "1/6",
					id: "realizace_patro",
					label: "Patro",
					placeholder: "1"
				}),
				FieldText({
					width: "2/6",
					id: "realizace_termin",
					label: "Termín realizace",
					placeholder: "d.m.R"
				})
			]),
			Row({}, [
				FieldText({
					id: "aktualni_stav",
					label: "Aktuální stav",
					placeholder: "Novostavba? Přestavba? Hotové instalace? Zdi?"
				}),
			]),
			Row({}, [
				FieldText({
					id: "dalsi_informace",
					label: "Další informace",
					placeholder: "Počet lidí v domácnosti? Kdo a jak často vaříte?"
				}),
			]),
			Row({}, [
				FieldText({
					id: "tvar_kuchyne",
					label: "Tvar kuchyně",
					placeholder: "..."
				}),
			]),
			Row({}, [
				FieldText({
					id: "misto_pro_poznamky",
					label: "Místo pro poznámky",
					placeholder: ""
				})
			])
		]),
	]),
	SectionGroup({}, [
		Section({
			id: "spotrebice",
			title: "Spotřebiče"
		}, [
			Row({
				id: "lednice"
			}, [
				FieldLabel({
					width: "1/6",
					label: "Lednice"
				}),
				FieldSelect({
					id: "umisteni",
					options: [{
						value: "_",
						label: "-"
					}, {
						value: "volne_stojici",
						label: "Volně stojící"
					}, {
						value: "vestavna",
						label: "Vestavná"
					}]
				}),
				FieldSelect({
					id: "velikost",
					options: [{
						value: "_",
						label: "-"
					}, {
						value: "vysoka",
						label: "Vysoká"
					}, {
						value: "pod_pd",
						label: "Pod pracovní desku"
					}, {
						value: "amerika",
						label: "Amerika"
					}]
				}),
			]),
			Row({
				id: "mycka"
			}, [
				FieldLabel({
					width: "1/6",
					label: "Myčka"
				}),
				FieldSelect({
					width: "1/3",
					id: "umisteni",
					options: [{
						value: "_",
						label: "-"
					}, {
						value: "volne_stojici",
						label: "Volně stojící"
					}, {
						value: "vestavna",
						label: "Vestavná"
					}]
				}),
				FieldText({
					width: "1/6",
					id: "velikost",
					placeholder: "450 - 600"
				}),
				FieldSelect({
					id: "typ",
					options: [{
						value: "_",
						label: "-"
					}, {
						value: "integrovana",
						label: "Integrovaná"
					}, {
						value: "ovladaci_panel",
						label: "S ovládacím panelem"
					}]
				}),
			]),
			Row({
				id: "vareni"
			}, [
				FieldLabel({
					width: "1/6",
					label: "Vaření"
				}),
				FieldSelect({
					width: "1/3",
					id: "typ",
					options: [{
						value: "_",
						label: "-"
					}, {
						value: "sklokeramika",
						label: "Sklokeramika"
					}, {
						value: "indukce",
						label: "Indukce"
					}, {
						value: "plyn",
						label: "Plyn"
					}]
				}),
				FieldText({
					id: "pribory",
					placeholder: "Uložení příborů"
				})
			]),
			Row({
				id: "trouba"
			}, [
				FieldLabel({
					width: "1/6",
					label: "Trouba"
				}),
				FieldSelect({
					width: "1/3",
					id: "umisteni",
					options: [{
						value: "_",
						label: "-"
					}, {
						value: "pod_vareni",
						label: "Pod vaření"
					}, {
						value: "do_vysky",
						label: "Do výšky"
					}]
				}),
				FieldText({
					id: "design",
					placeholder: "Design?"
				})
			]),
			Row({
				id: "mvt"
			}, [
				FieldLabel({
					width: "1/6",
					label: "Mikrovlnná trouba"
				}),
				FieldSelect({
					id: "umisteni",
					options: [{
						value: "_",
						label: "-"
					}, {
						value: "volne",
						label: "Volně"
					}, {
						value: "vestavna",
						label: "Vestavná"
					}]
				}),
				FieldSelect({
					id: "velikost",
					options: [{
						value: "_",
						label: "-"
					}, {
						value: "do_vysky",
						label: "Do výšky"
					}, {
						value: "na_pd",
						label: "Na pracovní desce"
					}, {
						value: "schovana",
						label: "Schovaná"
					}]
				}),
			]),
			Row({
				id: "digestor"
			}, [
				FieldLabel({
					width: "1/6",
					label: "Digestoř"
				}),
				FieldSelect({
					width: "1/3",
					id: "umisteni",
					options: [{
						value: "_",
						label: "-"
					}, {
						value: "kominova",
						label: "Komínová"
					}, {
						value: "vestavna",
						label: "Vestavná"
					}]
				}),
				FieldText({
					width: "1/6",
					id: "velikost",
					placeholder: "600 - 900"
				}),
				FieldSelect({
					id: "odtah",
					options: [{
						value: "_",
						label: "-"
					}, {
						value: "ano",
						label: "Odtah ano"
					}, {
						value: "ne",
						label: "Odtah ne"
					}]
				}),
			]),
			Row({
				id: "drez"
			}, [
				FieldLabel({
					width: "1/6",
					label: "Dřez"
				}),
				FieldSelect({
					width: "1/3",
					id: "typ",
					options: [{
						value: "_",
						label: "-"
					}, {
						value: "s_odkapem",
						label: "S odkapem"
					}, {
						value: "jedna_vana",
						label: "Jedna vana"
					}]
				}),
				FieldSelect({
					id: "strana",
					options: [{
						value: "_",
						label: "-"
					}, {
						value: "leva",
						label: "Levák"
					}, {
						value: "prava",
						label: "Pravák"
					}]
				}),
				FieldSelect({
					id: "material",
					options: [{
						value: "_",
						label: "-"
					}, {
						value: "nerez",
						label: "Nerez"
					}, {
						value: "granit",
						label: "Granit"
					}, {
						value: "keramika",
						label: "Keramika"
					}]
				})
			]),
			Row({
				id: "baterie"
			}, [
				FieldLabel({
					width: "1/6",
					label: "Baterie"
				}),
				FieldSelect({
					width: "1/3",
					id: "typ",
					options: [{
						value: "_",
						label: "-"
					}, {
						value: "stojankova",
						label: "Stojánková"
					}, {
						value: "na_zdi",
						label: "Na zdi"
					}]
				}),
				FieldSelect({
					id: "provedeni",
					options: [{
						value: "_",
						label: "-"
					}, {
						value: "sprcha",
						label: "Sprcha"
					}, {
						value: "klasika",
						label: "Klasika"
					}]
				})
			]),
			Row({
				id: "kos"
			}, [
				FieldLabel({
					width: "1/6",
					label: "Koš"
				}),
				FieldSelect({
					id: "typ",
					options: [{
						value: "_",
						label: "-"
					}, {
						value: "mensi_na_dvere",
						label: "Menší na dveře"
					}, {
						value: "trideni_do_vysuvu",
						label: "Třídení do výsuvu"
					}, {
						value: "vlastni",
						label: "Vlastní"
					}]
				})
			]),
			Row({
				id: "osvetleni"
			}, [
				FieldLabel({
					width: "1/6",
					label: "Osvětlení"
				}),
				FieldSelect({
					id: "typ",
					options: [{
						value: "_",
						label: "-"
					}, {
						value: "zarivka",
						label: "Zářivka"
					}, {
						value: "led_listy",
						label: "LED lišty"
					}, {
						value: "vlastni",
						label: "Vlastní"
					}]
				})
			]),
			Row({
				id: "jine"
			}, [
				FieldText({
					id: "dalsi_pozadavky",
					label: "Další požadavky",
					placeholder: "Jiný spotřebič/požadavky? Robot? Velké spotřebiče? Potravinová skříň?"
				}),
			]),
			Row({
				id: "jine"
			}, [
				FieldText({
					id: "preferovana_znacka_spotrebicu",
					label: "Preferovaná značka spotřebičů"
				}),
			]),
			Row({}, [
				FieldText({
					id: "misto_pro_poznamky",
					label: "Místo pro poznámky",
					placeholder: ""
				})
			])
		])
	]),
	SectionGroup({}, [
		Section({
			id: "provedeni_sestavy",
			title: "Provedení sestavy nábytku"
		}, [
			Row({
				id: "dvere"
			}, [
				FieldLabel({
					width: "1/3",
					label: "Dveře"
				}),
				FieldText({
					id: "dvere"
				})
			]),
			Row({
				id: "korpus"
			}, [
				FieldLabel({
					width: "1/3",
					label: "Korpus"
				}),
				FieldText({
					id: "korpus"
				})
			]),
			Row({
				id: "otevirani_hornich_skrinek"
			}, [
				FieldLabel({
					width: "1/3",
					label: "Otevírání horních skříněk"
				}),
				FieldText({
					id: "otevirani_hornich_skrinek"
				})
			]),
			Row({
				id: "otevirani_spodnich_skrinek"
			}, [
				FieldLabel({
					width: "1/3",
					label: "Otevírání spodních skříněk"
				}),
				FieldText({
					id: "otevirani_spodnich_skrinek"
				})
			]),
			Row({
				id: "pd"
			}, [
				FieldLabel({
					width: "1/3",
					label: "Pracovní deska"
				}),
				FieldText({
					id: "pd"
				})
			]),
			Row({
				id: "obklad_za_linku"
			}, [
				FieldLabel({
					width: "1/3",
					label: "Obklad za linku"
				}),
				FieldText({
					id: "obklad_za_linku"
				})
			]),
			Row({
				id: "sokl"
			}, [
				FieldLabel({
					width: "1/3",
					label: "Sokl"
				}),
				FieldText({
					id: "sokl"
				})
			]),
			Row({
				id: "uchytka"
			}, [
				FieldLabel({
					width: "1/3",
					label: "Úchytka"
				}),
				FieldText({
					id: "uchytka"
				}),
			]),
			Row({}, [
				FieldText({
					id: "misto_pro_poznamky",
					label: "Místo pro poznámky",
					placeholder: ""
				})
			])
		])
	]),
	SectionGroup({}, [
		Section({
			id: "rondo_kuchyne",
			title: "RONDO kuchyně"
		}, [
			Row({}, [
				FieldText({
					id: "stul-v-kuchyni",
					label: "Stůl v kuchyni"
				}),
			]),
			Row({}, [
				FieldText({
					id: "atypicky-rozmerne-vybaveni",
					label: "Uložení atypicky rozměrného vybavení"
				}),
			]),
			Row({}, [
				FieldText({
					id: "potraviny",
					label: "Uložení potravin"
				}),
			]),
			Row({}, [
				FieldText({
					id: "misto_pro_poznamky",
					label: "Místo pro poznámky",
					placeholder: ""
				})
			])
		])
	]),
	SectionGroup({}, [
		Section({
			id: "ostatni",
			title: "Ostatní"
		}, [
			Row({}, [
				FieldText({
					id: "jak_se_o_nas_zakaznik_dozvedel",
					label: "Jak se o nás zákazník dozvěděl?"
				}),
			]),
			Row({}, [
				FieldText({
					id: "zmena_na_puvodni_lince",
					label: "Co by chtěl změnit na původní lince?"
				}),
			]),
			Row({}, [
				FieldText({
					id: "rozpocet",
					label: "Rozpočet"
				}),
			]),
			Row({}, [
				FieldText({
					id: "poznamky",
					label: "Další poznámky"
				}),
			])
		])
	]),
	SectionGroup({}, [
		Section({
			id: "podpisova_sekce",
			title: "Potvrzení převzetí formuláře"
		}, [
			Row({
				id: "podpisy"
			}, [
				HTMLContent({}, (data) => <>
					<table style={{
						width: "100%"
					}}>
						<tr>
							<td style={{
								width: "50%",
								textAlign: "center",
								verticalAlign: "middle",
								padding: "15px",
								paddingTop: "30px"
							}}
								colSpan={2}
							>
								V Českých Budějovicích, dne:
                            </td>
						</tr>
						<tr>
							<td style={{
								width: "50%",
								textAlign: "center",
								verticalAlign: "middle",
								padding: "15px",
								paddingTop: "100px"
							}}>
								<p>
									. . . . . . . . . . . . . . . . . . . .
                                </p>
								<p>
									<strong>Podpis a razítko<br />prodejce</strong>
								</p>
							</td>
							<td style={{
								width: "50%",
								textAlign: "center",
								verticalAlign: "middle",
								padding: "15px",
								paddingTop: "100px"
							}}>
								<p>
									. . . . . . . . . . . . . . . . . . . .
                                </p>
								<p>
									<strong>Podpis<br />zákazníka</strong>
								</p>
							</td>
						</tr>
					</table>
				</>)
			]),
		])
	])
]);